import { findDeploymentEnvFromHostName, findStageFromHostName, findCDNBaseUrlFromHostName } from './serverEnvService.js';

const findDeploymentEnvFromUrl = () => {
    return findDeploymentEnvFromHostName(window.location.hostname);
};
const findStageFromUrl = () => {
    return findStageFromHostName(window.location.hostname);
};
const findCDNBaseUrlFromUrl = () => {
    return findCDNBaseUrlFromHostName(window.location.hostname);
};

export { findCDNBaseUrlFromUrl, findDeploymentEnvFromUrl, findStageFromUrl };
//# sourceMappingURL=envService.js.map
